import React, { useState, useEffect } from 'react';
import { API } from '../contexts/AuthContext';
import axios from 'axios';

export default function LogAtividades() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/log-atividades`).then(res => setLogs(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-5"><div className="spinner-border" style={{ color: '#6B2C5C' }} /></div>;

  return (
    <div>
      <h4 className="fw-bold mb-4">Log de Atividades</h4>
      <div className="card p-3">
        <div className="tabela-container">
          <table className="table table-mkt table-hover mb-0">
            <thead>
              <tr><th>Data/Hora</th><th>Usuário</th><th>Ação</th><th>Detalhes</th></tr>
            </thead>
            <tbody>
              {logs.map(l => (
                <tr key={l.id}>
                  <td style={{ fontSize: '0.83rem', whiteSpace: 'nowrap' }}>
                    {l.criado_em ? new Date(l.criado_em).toLocaleString('pt-BR', { timeZone: 'UTC' }) : '—'}
                  </td>
                  <td>{l.usuario_nome || '—'}</td>
                  <td><span className="badge-filial">{l.acao}</span></td>
                  <td style={{ fontSize: '0.83rem' }}>{l.detalhes}</td>
                </tr>
              ))}
              {logs.length === 0 && <tr><td colSpan="4" className="text-center text-muted">Nenhuma atividade registrada</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
